export enum SentidoRota {
    Norte = 78,
    Sul = 83
}